import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ushi.jpg")